var map = {
	"./Avatar.vue": "df3a",
	"./Badges.vue": "6fb7",
	"./Block.vue": "2efe",
	"./Block/Network.vue": "08b9",
	"./Block/Results.vue": "e5d5",
	"./Block/Votes.vue": "4696",
	"./Container.vue": "185a",
	"./Icon.vue": "cdae",
	"./Modal/About.vue": "8188",
	"./Modal/Account.vue": "34ec",
	"./Modal/Confirm.vue": "2982",
	"./Modal/Language.vue": "4bd5",
	"./Modal/Networks.vue": "a59c",
	"./Modal/Plugins.vue": "d17a",
	"./Modal/Proposal.vue": "c70b",
	"./Modal/ProposalConfirm.vue": "3e65",
	"./Modal/Receipt.vue": "b1dc",
	"./Modal/SelectDate.vue": "c4f1",
	"./Modal/Skins.vue": "7b6c",
	"./Modal/Strategies.vue": "bcae",
	"./Modal/User.vue": "74f8",
	"./Notifications.vue": "e985",
	"./PageLoading.vue": "2c10",
	"./Plugin/Aragon.vue": "2fd7",
	"./RowLoading.vue": "cb5e",
	"./RowProposal.vue": "b76b",
	"./Search.vue": "c106",
	"./State.vue": "6d6f",
	"./StatefulIcon.vue": "6f6f",
	"./Sticky.vue": "c6f5",
	"./Token.vue": "837d",
	"./Topnav.vue": "2fc9",
	"./Ui/Button.vue": "64c4",
	"./Ui/Calendar.vue": "5990",
	"./Ui/Counter.vue": "2fbf",
	"./Ui/Label.vue": "8af8",
	"./Ui/Loading.vue": "d1e9",
	"./Ui/Markdown.vue": "62f1",
	"./Ui/Modal.vue": "ae01",
	"./Ui/Progress.vue": "7f4b",
	"./User.vue": "7088"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4daf";